import React, { useCallback, useEffect, useMemo, useRef, useState, forwardRef } from 'react';
import { SwipeAction, Dialog, Button, Ellipsis, SearchBar } from 'antd-mobile';

import { useNavigate } from 'react-router-dom';

import arrowUrl from '@/assets/arrow.png';

import type { CityInfo } from '@/apis/address';
import { SELECT_CITY } from '@/constants/path';
import './index.less';

interface IProps {
  cityInfo: Partial<CityInfo>;
  searchBarPlaceholder?: string;
  onFocus?: () => void;
  onChange?: (keyword: string) => void;
  onSearch?: (keyword: string) => void;
  onChangeCity?: () => void;
}

const searchIcon = (
  <svg
    version="1.1"
    style={{ paddingTop: '3px' }}
    width="20px"
    height="20px"
    viewBox="0 0 26.0 26.0"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <defs>
      <clipPath id="i0">
        <path d="M26,0 L26,26 L0,26 L0,0 L26,0 Z"></path>
      </clipPath>
      <clipPath id="i1">
        <path d="M7.68240366,-3.90798505e-14 C11.925278,-3.90798505e-14 15.3648073,3.43952928 15.3648073,7.68240366 C15.3648073,11.7253734 12.2417523,15.0389145 8.27649197,15.3421772 L8.27615366,17.8601969 C8.27615366,18.1881159 8.01032273,18.4539469 7.68240366,18.4539469 C7.35448459,18.4539469 7.08865366,18.1881159 7.08865366,17.8601969 L7.08831534,15.3421772 C3.12305506,15.0389145 -1.15463195e-14,11.7253734 -1.15463195e-14,7.68240366 C-1.15463195e-14,3.43952928 3.43952928,-3.90798505e-14 7.68240366,-3.90798505e-14 Z M7.68240366,1.1875 C4.09536742,1.1875 1.1875,4.09536742 1.1875,7.68240366 C1.1875,11.2694399 4.09536742,14.1773073 7.68240366,14.1773073 C11.2694399,14.1773073 14.1773073,11.2694399 14.1773073,7.68240366 C14.1773073,4.09536742 11.2694399,1.1875 7.68240366,1.1875 Z"></path>
      </clipPath>
    </defs>
    <g clipPath="url(#i0)">
      <g transform="translate(12.354206359011101 1.1741912670577754) rotate(-44.99999999999999) scale(-1.0 1.0)">
        <g clipPath="url(#i1)">
          <polygon
            points="1.30562228e-13,-3.90798505e-14 15.3648073,-3.90798505e-14 15.3648073,18.4539469 1.30562228e-13,18.4539469 1.30562228e-13,-3.90798505e-14"
            stroke="none"
            fill="#999999"></polygon>
        </g>
      </g>
    </g>
  </svg>
);

const AddressSearchBar = forwardRef<React.HTMLProps<IProps>, IProps>((props: IProps, ref) => {
  const { cityInfo, searchBarPlaceholder, onFocus, onSearch, onChangeCity, onChange } = props;

  const navigate = useNavigate();

  const handleFocus = useCallback(() => {
    onFocus && onFocus();
  }, [onFocus]);
  const handleChange = useCallback(
    (val: string) => {
      onChange && onChange(val);
    },
    [onChange],
  );

  const { code, name: cityName = '' } = cityInfo || {};
  return (
    <div className="search-wrapper" ref={ref as React.LegacyRef<HTMLDivElement>}>
      <div
        className="left"
        onClick={() => {
          if (onChangeCity) {
            onChangeCity();
            return;
          }
          navigate(SELECT_CITY);
        }}>
        <Ellipsis content={code ? cityName : '请选择城市'} />
        <img src={arrowUrl} />
      </div>
      <div className="search">
        <SearchBar
          placeholder={searchBarPlaceholder || '搜索路名/小区/写字楼/学校等'}
          style={{ '--background': '#ffffff', '--padding-left': '5px' }}
          icon={searchIcon}
          onFocus={handleFocus}
          onSearch={(keyword) => {
            onSearch && onSearch(keyword);
          }}
          onChange={handleChange}
        />
      </div>
    </div>
  );
});

AddressSearchBar.displayName = 'AddressSearchBar';

export default AddressSearchBar;
